// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2561":"1ea9faeb","5724":"392f28ec","7620":"392f28ec","7989":"3d93e2cb"}[chunkId] + ".chunk.css";
};